import axios from "axios";

const instance = axios.create({
    baseURL: "https://amazonclone-back.herokuapp.com/" // the api (cloud function) URL

});

export default instance;